export const calculateBoosting = (arr) => {
  const summ = arr.reduce((accumulator, currentValue) => accumulator + (currentValue.boostEdited || 0), 0)
  return summ / arr.length
}

export const minBoosting = (arr) => Math.min(...arr.map((item) => item.boostEdited))

export const maxBoosting = (arr) => Math.max(...arr.map((item) => item.boostEdited))
